import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListBankPaymentsAction = "LIST_BANK_PAYMENTS";
const ListBankPaymentsDailyAction = "LIST_BANK_PAYMENTS_DAILY";
const Waiting = "WAITING";

const initialState = {
    list: [],
    listDaily: [],
    nowWainting: false,
    editing: null,
    bankPaymentTotal: null,
};
export const actionCreators = {
    /**
     * 銀行の売上明細リストを取得します。
     */
    listBankPayments: (token, startDt, endDt, bankId, paymentAgencyId, bankPaymentKind) => async (dispatch) => {
        const routeurl = `api/user/bankPayments/list`;

        var param = '';
        if (startDt != "" && startDt != null && startDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const sdt = new Date(startDt);
            sdt.setDate(sdt.getDate());
            let dt = sdt.getFullYear() + '/' + ("0" + (sdt.getMonth() + 1)).slice(-2) + '/' + ("0" + sdt.getDate()).slice(-2);
            param += `sdt=${dt}`;
        }
        if (endDt != "" && endDt != null && endDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const edt = new Date(endDt);
            edt.setDate(edt.getDate());
            let dt = edt.getFullYear() + '/' + ("0" + (edt.getMonth() + 1)).slice(-2) + '/' + ("0" + edt.getDate()).slice(-2);
            param += `edt=${dt}`;
        }
        if (bankId != "" && bankId != null && bankId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `bankId=${bankId}`;
        }
        if (paymentAgencyId != "" && paymentAgencyId != null && paymentAgencyId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `agencyId=${paymentAgencyId}`;
        }
        if (bankPaymentKind != "" && bankPaymentKind != null && bankPaymentKind != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `kind=${bankPaymentKind}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const temp = await response.json();
                // 明細行を取得
                const list = temp.filter(x => x.bank_id != null);
                // 合計行を取得
                const total = temp.filter(x => x.bank_id == null);
                var paymentTotal = '';
                if (total.length > 0) {
                    // 合計値を取得
                    // ￥マーク、カンマ処理
                    paymentTotal = Number(total[0].bank_payment).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
                }
                dispatch({ type: ListBankPaymentsAction, list, bankPaymentTotal: paymentTotal});
                return list;
            } else {
                throw new Error('銀行の売上明細リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 銀行の売上明細（日別）リストを取得します。
     */
    listBankPaymentsDaily: (token, startDt, endDt, bankId, paymentAgencyId, bankPaymentKind) => async (dispatch) => {
        const routeurl = `api/user/bankPayments/list_daily`;

        var param = '';
        if (startDt != "" && startDt != null && startDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const sdt = new Date(startDt);
            sdt.setDate(sdt.getDate());
            let dt = sdt.getFullYear() + '/' + ("0" + (sdt.getMonth() + 1)).slice(-2) + '/' + ("0" + sdt.getDate()).slice(-2);
            param += `sdt=${dt}`;
        }
        if (endDt != "" && endDt != null && endDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            const edt = new Date(endDt);
            edt.setDate(edt.getDate());
            let dt = edt.getFullYear() + '/' + ("0" + (edt.getMonth() + 1)).slice(-2) + '/' + ("0" + edt.getDate()).slice(-2);
            param += `edt=${dt}`;
        }
        if (bankId != "" && bankId != null && bankId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `bankId=${bankId}`;
        }
        if (paymentAgencyId != "" && paymentAgencyId != null && paymentAgencyId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `agencyId=${paymentAgencyId}`;
        }
        if (bankPaymentKind != "" && bankPaymentKind != null && bankPaymentKind != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `kind=${bankPaymentKind}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const listDaily = await response.json();
                dispatch({ type: ListBankPaymentsDailyAction, listDaily: listDaily });
                return listDaily;
            } else {
                throw new Error('銀行の売上明細（日別）リストの取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 一覧を初期化します。
     */
    initListInfo: () => async (dispatch) => {
        dispatch({ type: ListBankPaymentsAction, list: [], nowWainting: false });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListBankPaymentsAction) {
        return {
            ...state,
            list: action.list,
            bankPaymentTotal: action.bankPaymentTotal,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListBankPaymentsDailyAction) {
        return {
            ...state,
            listDaily: action.listDaily,
            nowWainting: action.nowWainting
        };
    }
    return state;
}